<!-- 达人刊例 -->
<template>
  <div class="talent-monthly">
    <div class="content">
      <div class="tabs-wrap">
        <el-tabs class="tabs" v-model="activeName">
          <el-tab-pane name="first">
            <span slot="label" class="label"><img class="label_icon" src="../../assets/douyin.png" alt="" />抖音达人</span>
          </el-tab-pane>
          <el-tab-pane name="second">
            <span slot="label" class="label"><img class="label_icon" src="../../assets/kuaishou.png" alt="">快手达人</span>
          </el-tab-pane>
          <el-tab-pane name="third">
            <span slot="label" class="label"><img class="label_icon" src="../../assets/bilibili.png" alt="">bilibili达人</span>
          </el-tab-pane>
          <el-tab-pane name="fourth">
            <span slot="label" class="label"><img class="label_icon" src="../../assets/xhs.png" alt="">小红书达人</span>
          </el-tab-pane>
        </el-tabs>
        <span class="sp-tip">每周一自动更新本月刊例达人数据</span>
      </div>
    <Table :plat="activeName=='first'?'dy':activeName=='second'?'ks':activeName=='third'?'bili':activeName=='fourth'?'xhs':''"></Table>
    </div>
  </div>
</template>
<script>

import Table from './component/Table';

export default {
  data() {
    return {
        activeName: "first",
    };
  },
  components:{
    Table,
  },
  created() {
  },
  methods: {
  }
};
</script>

<style lang='less' scoped>
.talent-monthly{
  margin: 20px 0;
  .content{
    margin: 0 auto;
    width: calc(100% - 100px) ;
  }
  .tabs-wrap{
    position: relative;
    .sp-tip{
      position: absolute;
      top: 25%;
      right: 20px;
      color: red;
    }
  }
/deep/.el-tabs__content{
  padding: 0;
}
}
</style>